const STORAGE_KEYS = {
  // 控制显示quest页面的tutorial
  QUEST_TUTORIAL: 'questTutorialStep',
  // 控制显示learn页面的tutorial
  LEARN_TUTORIAL: 'learnTutorialStep',
  // 控制显示game页面的tutorial
  GAME_TUTORIAL: 'gameTutorialStep',
  // 控制显示quest页面的parent tutorial
  QUEST_PARENT_TUTORIAL: 'questParentTutorialStep',
  // 匿名用户id
  ANONYMOUS_USER_ID: 'anonymous_user_id',
  // 用户信息
  USER: 'user',
  ONBOARD_DATA: 'onboard-data',
  BROWSER_COMPATIBILITY_WARNING_DISMISSED: 'browser-compatibility-warning-dismissed',
  IS_FIRST_FLASH_CARD: 'isFirstFlashCard',
  IS_FIRST_LESSON_SUMMARY_CARD: 'isFirstLessonSummaryCard',
  CURRENT_SESSION_ID: 'current_session_id',
  AUDIO_SETTING_MUTED: 'audio-setting-muted',
  BETTER_EXPERIENCE_TIP: 'better-experience-tip',
}

export default STORAGE_KEYS;
